export class Folder {
  comment: string;
  url: string;
  guid: string;
  size: number;
  maxSize: number;
  createDateTime: Date;
  expirationDateTime: Date;
  password: string;
  published: boolean;

  clone(): Folder {
    const result = new Folder();
    result.comment = this.comment;
    result.url = this.url;
    result.guid = this.guid;
    result.size = this.size;
    result.maxSize = this.maxSize;
    result.createDateTime = this.createDateTime;
    result.expirationDateTime = this.expirationDateTime;
    result.password = this.password;
    result.published = this.published;
    
    return result;
  }
}
